/* eslint-disable compat/compat */
import React from 'react'
import { string, arrayOf, shape } from 'prop-types'
import { graphql } from 'gatsby'
import { motion } from 'framer-motion'
import classNames from 'classnames'
import PageTitle from '@/components/PageTitle'
import Link from '@/utils/Link'
import withTheme from '@/utils/withTheme'
import Raw from '@/utils/Raw'
import SEOMatic from '@/components/SEOMatic'
import * as T from '@/types'
import ArrowIcon from '@/icons/arrow.svg'
import IconWrapper from '@/utils/IconWrapper'
import { fade } from '@/utils/transitions'

function News({
	pageContext: { pagination, baseUrl },
	data: {
		craft: { seo, entries },
	},
}) {
	return (
		<>
			<SEOMatic {...seo} />
			<div className="pt-32">
				<motion.div variants={fade} initial="initial" className="px-8 wrapper">
					<PageTitle className="mb-12 text-rust">News</PageTitle>
				</motion.div>

				<motion.ul
					variants={fade}
					initial="initial"
					className="w-full border-t md:flex md:flex-wrap border-soft"
				>
					{entries.map((post, index) => (
						<motion.li
							className="border-b border-soft md:w-1/2 md:odd:border-r"
							key={post.id}
							variants={fade}
							initial="initial"
						>
							<div
								className={classNames('py-8', {
									'lg:ml-auto lg:max-w-half/wrapper': index % 2 === 0,
									'lg:mr-auto lg:max-w-half/wrapper': index % 2 !== 0,
								})}
							>
								<div className="px-8">
									<time className="block mb-1 text-base font-medium text-rust">
										{post.date}
									</time>
									<h2 className="mb-1 mb-4 text-2xl font-medium leading-none text-orange lg:text-3xl lg:mb-6">
										<Link to={`${baseUrl}${post.uri}`}>{post.title}</Link>
									</h2>
									<Raw content={post.intro} className="mb-8 text-orange" />
									<Link
										to={`${baseUrl}${post.uri}`}
										aria-label={`Read more about: ${post.title}`}
										className="text-orange"
									>
										Read more
									</Link>
								</div>
							</div>
						</motion.li>
					))}
				</motion.ul>
				<motion.div variants={fade} initial="initial">
					<div className="flex justify-between px-8 py-2 wrapper">
						{pagination.prev && (
							<Link
								to={pagination.prev}
								className="flex items-center py-2 mr-auto text-lg font-medium group"
							>
								<IconWrapper
									icon={ArrowIcon}
									className="w-10 mr-4 transition-transform duration-300 transform rotate-180 group-hover:-translate-x-2"
								/>
								Prev
							</Link>
						)}
						{pagination.next && (
							<Link
								to={pagination.next}
								className="flex items-center py-2 ml-auto text-lg font-medium group"
							>
								Next
								<IconWrapper
									icon={ArrowIcon}
									style={{ willChange: 'transform' }}
									className="w-10 ml-4 transition-transform duration-300 transform translate-x-0 group-hover:translate-x-2"
								/>
							</Link>
						)}
					</div>
				</motion.div>
			</div>
		</>
	)
}

News.propTypes = {
	pageContext: shape({
		baseUrl: string.isRequired,
		// posts: arrayOf(
		// 	shape({
		// 		title: string.isRequired,
		// 		intro: string.isRequired,
		// 		uri: string.isRequired,
		// 		id: string.isRequired,
		// 	})
		// ),
	}),
	// location: shape({
	// 	pathname: string.isRequired,
	// }),
	data: shape({
		craft: shape({
			seo: T.seomatic,
		}),
	}),
}

export const query = graphql`
	query NewsListQuery($seo: String, $siteStr: String, $offset: Int) {
		craft {
			seo: seomatic(uri: $seo, asArray: true) {
				...seoQuery
			}
			entries(section: "news", siteId: $siteStr, limit: 10, offset: $offset) {
				... on Craft_news_news_Entry {
					id
					url
					uri
					slug
					siteId
					intro
					title
					postDate
				}
			}
		}
	}
`

export default withTheme(News, 'rust')
